export default __webpack_public_path__ + "static/media/6.e1f8aff9.svg";